import { useCallback } from 'react';
import { ACTIVE_PRODUCT_GALLERY_SELECTORS } from '../constants';
import { cartAnimation } from '../utils/cart-fly-item';

interface UseCartAnimationParams {
    variant: string;
}

export const useCartAnimation = ({ variant }: UseCartAnimationParams) => {
    const getVisibleProductGalleryImage = useCallback((): HTMLElement | null => {
        for (const selector of ACTIVE_PRODUCT_GALLERY_SELECTORS) {
            const activeImage = document.querySelector<HTMLElement>(selector);

            if (activeImage) {
                const rect = activeImage.getBoundingClientRect();

                if (rect.width > 0 && rect.height > 0) {
                    return activeImage;
                }
            }
        }

        const images = Array.from(document.querySelectorAll<HTMLElement>('.product-gallery img'));

        return (
            images.find(image => {
                const rect = image.getBoundingClientRect();
                const style = globalThis.getComputedStyle(image);

                return (
                    rect.width > 0 &&
                    rect.height > 0 &&
                    style.display !== 'none' &&
                    style.visibility !== 'hidden' &&
                    style.opacity !== '0'
                );
            }) ?? null
        );
    }, []);

    const runCartAnimation = useCallback(
        (event?: React.MouseEvent<HTMLButtonElement>) => {
            if (!event) {
                return;
            }

            const imageElement = variant === 'quick' ? null : getVisibleProductGalleryImage();

            void cartAnimation({
                triggerEvent: event,
                imageElement,
            });
        },
        [getVisibleProductGalleryImage, variant]
    );

    return {
        runCartAnimation,
    };
};
